module.exports = "<history-warning-list terms=\"vm.terms\"></history-warning-list>"